export const NoteModule = Object.freeze({
  Overview: 'Overview',
  WellDetails: 'WellDetails',
  ActivityModel: 'ActivityModel',
  Risks: 'Risks',
  CostSetup: 'CostSetup',
  ResultOverview: 'ResultOverview',
  TimeTracker: 'TimeTracker',
});
